<div class="live-sources-container">
  <header class="live-sources-header">
    <div class="live-sources-header__top">
      <div class="live-sources-header__title-group">
        <h1 class="live-sources-title">Live Sources</h1>
      </div>
      <div class="live-sources-header__actions">
        <button type="button" class="live-sources-header__btn live-sources-header__btn--primary" aria-label="Add new live source">
          Add New Live Source
        </button>
      </div>
    </div>
    <evrideo-live-sources-toolbar
      [searchQuery]="state.searchQuery()"
      [statusFilter]="state.statusFilter()"
      [protocolFilter]="state.protocolFilter()"
      (searchChange)="onSearchChange($event)"
      (statusChange)="onStatusChange($event)"
      (protocolChange)="onProtocolChange($event)"
    ></evrideo-live-sources-toolbar>
  </header>

  <div class="live-sources-content">
    @if (state.isLoading()) {
      <div class="live-sources-loading">Loading live sources...</div>
    } @else if (state.error()) {
      <div class="live-sources-error">
        <p>{{ state.error() }}</p>
        <button (click)="loadAllData()">Reload</button>
      </div>
    } @else {
      <evrideo-live-sources-grid
        [sources]="state.filteredSources()"
        (deleteSource)="onDeleteSource($event)"
      ></evrideo-live-sources-grid>
    }
  </div>
</div>
